module.exports = __webpack_public_path__ + "img/addgroupicon.95954623.svg";